import { render, staticRenderFns } from "./BulkEditDialog.vue?vue&type=template&id=260b03c6&"
import script from "./BulkEditDialog.vue?vue&type=script&lang=js&"
export * from "./BulkEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports